export const getPreviewImages = state => state.previewImages.images;
